<div class="chart-container">
  <div class="chart-heading">Overall Threats Seen by Sector</div>

  <div class="icon-container">
    <i [class]="'bi ' + (minimizeDonut ? 'bi-arrows-angle-expand' : 'bi-dash-circle')" (click)="minimizedDonut()"></i>
    <i [class]="'bi ' + (minimizeBar ? 'bi-arrows-angle-expand' : 'bi-dash-circle')" (click)="minimizedBar()"></i>
  </div>

  @if (allIndustryData.length > 0) {
    <div class="stats">
      @if (!minimizeDonut) {
        <div class="pie-container">
          <app-donut-chart [total_threat_data]="allIndustryData"></app-donut-chart>
        </div>
      }
      @if (!minimizeBar) {
        <div class="bar-container">
          <app-bar-chart [bar_threat_data]="allIndustryData"></app-bar-chart>
        </div>
      }
    </div>
  } @else {
    <div class="stats">
      <p style="color: gray; padding: 1rem;">Loading sector data…</p>
    </div>
  }
</div>